'use strict'

// Credit card/shipping address same show/hide
const checkoutForm = document.querySelector('.coForm')
if(checkoutForm){

	// Same delivery/shipping address checkbox
	const sameEl = checkoutForm.querySelector('[name="same"]')
	if(sameEl){
		let showing = true

		// Get all elements below checkbox
		const formEl = document.querySelector('.coForm')
		const allEls = [].slice.call(formEl.querySelectorAll('form > *'))
		// Remove submit button
		for(let i = allEls.length; i--;){
			if(allEls[i].getAttribute('type') === 'submit' || allEls[i].classList.contains('secure')){
				allEls.splice(i, 1)
			}
		}
		const otherEls = formEl.querySelectorAll('.condHide')
		const condReqEls = formEl.querySelectorAll('.condRequire')

		// Set required
		function setRequire(){
			showing = true
			for(let i = otherEls.length; i--;){
				if(otherEls[i].getAttribute('type') === 'checkbox' || otherEls[i].tagName === 'LABEL'){
					otherEls[i].style.display = 'inline-block'
				}
				else{
					otherEls[i].style.display = 'block'
				}
			}
			for(let i = condReqEls.length; i--;){
				condReqEls[i].required = true
			}
		}
		function removeRequire(){
			showing = false
			for(let i = otherEls.length; i--;){
				otherEls[i].style.display = 'none'
			}
			for(let i = condReqEls.length; i--;){
				condReqEls[i].required = false
			}
		}
		if(sameEl.checked){
			removeRequire()
		}
		else{
			setRequire()
		}

		sameEl.addEventListener('change', () => {
			if(showing){
				removeRequire()
			}
			else{
				setRequire()
			}
		})
	}

}
